exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".switch-pad{font-size:16px;line-height:24px;font-weight:inherit;border-radius:8px;border:solid 1px #e9ebec;background-color:#fff}.switch-pad__option{padding:0 8px;height:24px;border:0;background:rgba(0,0,0,0);color:#727e82;border-radius:inherit;min-width:64px}.switch-pad__option--selected{background-color:#3fa2f7;color:#fff;font-weight:bold;border-radius:inherit}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};